export const translations = {
  pt: {
    appName: "FUTURO PDV",
    tagline: "Trabalho, conexões e mobilidade em um só lugar",
    login: "Entrar",
    register: "Cadastrar",
    email: "E-mail",
    password: "Senha",
    name: "Nome",
    loginGoogle: "Entrar com Google",
    logout: "Sair",
    or: "ou",
    haveAccount: "Já tem uma conta?",
    noAccount: "Não tem conta?",
    // Nav
    social: "Social",
    work: "Trabalho",
    mobility: "Mobilidade",
    chat: "Futuro Chat",
    profile: "Perfil",
    // Feed
    whatsOnMind: "No que você está pensando?",
    post: "Publicar",
    like: "Curtir",
    comment: "Comentar",
    share: "Compartilhar",
    comments: "comentários",
    likes: "curtidas",
    writeComment: "Escreva um comentário...",
    send: "Enviar",
    imageUrl: "URL da imagem (opcional)",
    // Jobs
    jobsMarketplace: "Trabalhos em Tempo Real",
    createJob: "Publicar Trabalho",
    jobTitle: "Título",
    jobDescription: "Descrição",
    jobCategory: "Categoria",
    jobBudget: "Orçamento (R$)",
    jobLocation: "Localização",
    remote: "Remoto",
    apply: "Candidatar-se",
    yourProposal: "Sua proposta",
    yourPrice: "Seu preço (R$)",
    applied: "Candidatura enviada!",
    applications: "candidaturas",
    // Mobility
    whereTo: "Para onde vamos?",
    pickupLocation: "Local de embarque",
    destination: "Destino",
    chooseVehicle: "Escolha o veículo",
    car: "Carro",
    moto: "Moto",
    requestRide: "Solicitar",
    estimatedPrice: "Preço estimado",
    eta: "Chegada estimada",
    driverFound: "Motorista a caminho!",
    plate: "Placa",
    vehicle: "Veículo",
    payNow: "Pagar Agora",
    // Chat
    messages: "Mensagens",
    typeMessage: "Digite sua mensagem...",
    noThreads: "Nenhuma conversa ainda",
    // Payments
    checkout: "Finalizar Pagamento",
    paymentSuccess: "Pagamento confirmado!",
    paymentPending: "Confirmando pagamento...",
    paymentCanceled: "Pagamento cancelado",
    // Common
    loading: "Carregando...",
    error: "Erro",
    save: "Salvar",
    cancel: "Cancelar",
    close: "Fechar",
    bio: "Bio",
    editProfile: "Editar Perfil",
    joinNow: "Comece agora",
    heroTitle: "No FUTURO PDV, tudo que você faz vira dinheiro",
    heroSubtitle: "Curta, compartilhe, trabalhe, dirija — acumule moedas e saque na hora.",
    minutes: "min",
    driverMode: "Modo Motorista",
    becomeDriver: "Torne-se motorista",
    goOnline: "Ficar Online",
    goOffline: "Ficar Offline",
    online: "Online",
    offline: "Offline",
    pendingRides: "Corridas disponíveis",
    acceptRide: "Aceitar",
    completeRide: "Finalizar corrida",
    cancelRide: "Cancelar",
    noPendingRides: "Nenhuma corrida disponível agora",
    vehicleType: "Tipo de veículo",
    vehicleModel: "Modelo do veículo",
    plateLabel: "Placa",
    saveDriverInfo: "Salvar",
    searchingDriver: "Buscando motorista...",
    driverArriving: "Motorista a caminho",
    rideAccepted: "Corrida aceita!",
    notifications: "Notificações",
    noNotifs: "Nenhuma notificação",
    markAllRead: "Marcar tudo como lido",
    uploadPhoto: "Enviar foto",
    uploading: "Enviando...",
    driver: "Motorista",
  },
  en: {
    appName: "PDV Future",
    tagline: "Work, connections and mobility in one place",
    login: "Sign in",
    register: "Register",
    email: "Email",
    password: "Password",
    name: "Name",
    loginGoogle: "Sign in with Google",
    logout: "Sign out",
    or: "or",
    haveAccount: "Already have an account?",
    noAccount: "Don't have an account?",
    social: "Social",
    work: "Work",
    mobility: "Mobility",
    chat: "Futuro Chat",
    profile: "Profile",
    whatsOnMind: "What's on your mind?",
    post: "Post",
    like: "Like",
    comment: "Comment",
    share: "Share",
    comments: "comments",
    likes: "likes",
    writeComment: "Write a comment...",
    send: "Send",
    imageUrl: "Image URL (optional)",
    jobsMarketplace: "Real-time Jobs",
    createJob: "Post a Job",
    jobTitle: "Title",
    jobDescription: "Description",
    jobCategory: "Category",
    jobBudget: "Budget ($)",
    jobLocation: "Location",
    remote: "Remote",
    apply: "Apply",
    yourProposal: "Your proposal",
    yourPrice: "Your price ($)",
    applied: "Application sent!",
    applications: "applications",
    whereTo: "Where to?",
    pickupLocation: "Pickup",
    destination: "Destination",
    chooseVehicle: "Choose vehicle",
    car: "Car",
    moto: "Moto",
    requestRide: "Request",
    estimatedPrice: "Estimated price",
    eta: "ETA",
    driverFound: "Driver on the way!",
    plate: "Plate",
    vehicle: "Vehicle",
    payNow: "Pay Now",
    messages: "Messages",
    typeMessage: "Type your message...",
    noThreads: "No conversations yet",
    checkout: "Checkout",
    paymentSuccess: "Payment confirmed!",
    paymentPending: "Confirming payment...",
    paymentCanceled: "Payment canceled",
    loading: "Loading...",
    error: "Error",
    save: "Save",
    cancel: "Cancel",
    close: "Close",
    bio: "Bio",
    editProfile: "Edit Profile",
    joinNow: "Get Started",
    heroTitle: "The future of work, connections and mobility",
    heroSubtitle: "Post, find gigs and hail Car or Moto rides. All in one app.",
    minutes: "min",
    driverMode: "Driver Mode",
    becomeDriver: "Become a driver",
    goOnline: "Go Online",
    goOffline: "Go Offline",
    online: "Online",
    offline: "Offline",
    pendingRides: "Available rides",
    acceptRide: "Accept",
    completeRide: "Complete ride",
    cancelRide: "Cancel",
    noPendingRides: "No rides available now",
    vehicleType: "Vehicle type",
    vehicleModel: "Vehicle model",
    plateLabel: "Plate",
    saveDriverInfo: "Save",
    searchingDriver: "Finding a driver...",
    driverArriving: "Driver on the way",
    rideAccepted: "Ride accepted!",
    notifications: "Notifications",
    noNotifs: "No notifications",
    markAllRead: "Mark all as read",
    uploadPhoto: "Upload photo",
    uploading: "Uploading...",
    driver: "Driver",
  },
  es: {
    appName: "FUTURO PDV",
    tagline: "Trabajo, conexiones y movilidad en un solo lugar",
    login: "Entrar",
    register: "Registrarse",
    email: "Correo",
    password: "Contraseña",
    name: "Nombre",
    loginGoogle: "Entrar con Google",
    logout: "Salir",
    or: "o",
    haveAccount: "¿Ya tienes cuenta?",
    noAccount: "¿No tienes cuenta?",
    social: "Social",
    work: "Trabajo",
    mobility: "Movilidad",
    chat: "Futuro Chat",
    profile: "Perfil",
    whatsOnMind: "¿Qué estás pensando?",
    post: "Publicar",
    like: "Me gusta",
    comment: "Comentar",
    share: "Compartir",
    comments: "comentarios",
    likes: "me gusta",
    writeComment: "Escribe un comentario...",
    send: "Enviar",
    imageUrl: "URL de imagen (opcional)",
    jobsMarketplace: "Trabajos en Tiempo Real",
    createJob: "Publicar Trabajo",
    jobTitle: "Título",
    jobDescription: "Descripción",
    jobCategory: "Categoría",
    jobBudget: "Presupuesto ($)",
    jobLocation: "Ubicación",
    remote: "Remoto",
    apply: "Postular",
    yourProposal: "Tu propuesta",
    yourPrice: "Tu precio ($)",
    applied: "¡Postulación enviada!",
    applications: "postulaciones",
    whereTo: "¿A dónde?",
    pickupLocation: "Recogida",
    destination: "Destino",
    chooseVehicle: "Elegir vehículo",
    car: "Auto",
    moto: "Moto",
    requestRide: "Solicitar",
    estimatedPrice: "Precio estimado",
    eta: "Llegada",
    driverFound: "¡Conductor en camino!",
    plate: "Placa",
    vehicle: "Vehículo",
    payNow: "Pagar Ahora",
    messages: "Mensajes",
    typeMessage: "Escribe tu mensaje...",
    noThreads: "Sin conversaciones",
    checkout: "Pagar",
    paymentSuccess: "¡Pago confirmado!",
    paymentPending: "Confirmando pago...",
    paymentCanceled: "Pago cancelado",
    loading: "Cargando...",
    error: "Error",
    save: "Guardar",
    cancel: "Cancelar",
    close: "Cerrar",
    bio: "Bio",
    editProfile: "Editar Perfil",
    joinNow: "Empezar",
    heroTitle: "El futuro del trabajo, conexiones y movilidad",
    heroSubtitle: "Publica, encuentra freelance y pide Carro o Moto. Todo en una app.",
    minutes: "min",
    driverMode: "Modo Conductor",
    becomeDriver: "Ser conductor",
    goOnline: "Conectarse",
    goOffline: "Desconectarse",
    online: "En línea",
    offline: "Desconectado",
    pendingRides: "Viajes disponibles",
    acceptRide: "Aceptar",
    completeRide: "Terminar viaje",
    cancelRide: "Cancelar",
    noPendingRides: "Sin viajes disponibles",
    vehicleType: "Tipo de vehículo",
    vehicleModel: "Modelo",
    plateLabel: "Placa",
    saveDriverInfo: "Guardar",
    searchingDriver: "Buscando conductor...",
    driverArriving: "Conductor en camino",
    rideAccepted: "¡Viaje aceptado!",
    notifications: "Notificaciones",
    noNotifs: "Sin notificaciones",
    markAllRead: "Marcar todo como leído",
    uploadPhoto: "Subir foto",
    uploading: "Subiendo...",
    driver: "Conductor",
  },
};
